import React from "react"
import { Link } from "gatsby"
import { Row, Col, Container, Card, Button } from "react-bootstrap"
import { imageFile } from '../../components/Utilities/Image-file'
import ellipsize from 'ellipsize'
import Icon from "../../assets/ArrowWithStem.svg"
import Icon2 from "../../assets/ArrowVector.svg"
import Icon3 from "../../assets/Union.svg"
import IconPlay from "../../assets/icon-play.svg"
import { trackCustomEvent } from 'gatsby-plugin-google-analytics'
import FramerMotionAnimation from "../../components/Utilities/Animations/FramerMotion"
import UnderstandingFinanceImage from '../../components/Utilities/Understanding-finance-image'


// ARTICLE TEASER component
//
// Expects:
// data, exclude, title, limit

// data: nodes data object (title, drupal_internal__nid, path, created - per node) *
// exclude: an exclude id value (don't show this node)
// title: list title for context
// limit: limit to the number of nodes to display *
// colPattern: a repeating pattern for column sizes
// noMoreLink: if true the more link is hidden
// noDates: if true hide dates

// * typically one more node than needed is sent in case the page we are already on features in the list.  In this case we exclude

// EXAMPLE:
//
// <ArticleTeasers data={data (4 nodes)} excludeNode={1234} title="Related articles" limit={3} />



function teaserArticles(data, exclude, title, limit, colPattern, noMoreLink, noDates, classes, dataHome, downloadLinks) {
  //console.log(data)
  // console.log("exclude:"+exclude)
  // console.log(title)
  // console.log(limit)


  let colIndex = 0
  // default column pattern
  if(colPattern === undefined) {
    colPattern = {
      xs:[12],
      md:[6],
      lg:[4]
    }
  }
  let colIndexTot = colPattern.xs.length

  let moreLink = (
    <Col>
      <Link to="/our-insights/1">
        <Button variant="outline-primary">Read more Insights <Icon width="24" /></Button>
      </Link>
    </Col>
  )
  if(noMoreLink){
    moreLink = ""
  }

  // list output
  // -----------------------------------
  let list = []; // list layout container

  if(typeof data.nodes === 'object') {

    data.nodes.map(function(node, index) {

      let imageRelPath = "",
        field_article_category = ""

      if (node.relationships.field_article_category) {
        if (node.relationships.field_article_category[0]) {
          field_article_category = node.relationships.field_article_category[0].name
        }
      }

      // don't exceed limit
      // don't show a teaser to the page we are currently on (using the exlude)
      if ((list.length) < limit && node.drupal_internal__nid !== exclude)
      {
        if(node.relationships.field_image) {
          imageRelPath = imageFile(node.relationships.field_image, node.title)
        }

        // Add play button to the image.
        // Test for understanding finance image.
        let playButton, icoPlay = ""

        if(node.relationships) {
          if(node.relationships.field_article_category) {
            for (let i=0; i < node.relationships.field_article_category.length; i++) {
              if (node.relationships.field_article_category[i].name === "Video") {
                playButton = "video-button"
                icoPlay = (<IconPlay className="ico" />)
              }
              else if (node.relationships.field_article_category[i].name === "Understanding Finance") {
                imageRelPath = (
                  <UnderstandingFinanceImage />
                )
              }
            }
          }
        }

        let buttons = ""
        if(downloadLinks) {
          if(node.relationships.field_document_related_to_this_a) {
            if(node.relationships.field_document_related_to_this_a.relationships) {
              if(node.relationships.field_document_related_to_this_a.relationships.field_upload_document) {
                if(node.relationships.field_document_related_to_this_a.relationships.field_upload_document.name) {
                  let filename = node.relationships.field_document_related_to_this_a.relationships.field_upload_document.name

                  if(node.relationships.field_document_related_to_this_a.relationships.field_upload_document.relationships) {
                    if(node.relationships.field_document_related_to_this_a.relationships.field_upload_document.relationships.field_document) {
                      if(node.relationships.field_document_related_to_this_a.relationships.field_upload_document.relationships.field_document.localFile) {
                        if(node.relationships.field_document_related_to_this_a.relationships.field_upload_document.relationships.field_document.localFile.publicURL) {
                          let linkUrl = node.relationships.field_document_related_to_this_a.relationships.field_upload_document.relationships.field_document.localFile.publicURL

                          buttons = (
                            <>
                            <Link to={node.path.alias} className="btn btn-primary">Read more<Icon2 width="24" /></Link><br/>
                            <a onClick={e => {
                              trackCustomEvent({
                                category: "Document download",
                                action: "Click",
                                label: filename
                              })
                            }} href={linkUrl} title={filename} target="_blank" rel="noreferrer" className="btn btn-outline-primary">Download<Icon3 width="24" /></a>
                            </>
                          )
                        }
                      }
                    }
                  }
                }
              }
            }
          }

        }

        // let date = (
        //   <Card.Text className="article-date">{safeDate(node.created)}</Card.Text>
        // )
        // if(noDates) date = ""
        // list layout format/markup
        list.push (
          <Col key={index} xs={colPattern.xs[colIndex]} md={colPattern.md[colIndex]} lg={colPattern.lg[colIndex]} className={`page--list--item ${classes}`}>
              <Card>
                <div className={"card-image "+playButton}>
                  <Link to={node.path.alias}>
                    { icoPlay }
                    { imageRelPath }
                  </Link>
                </div>
                <Card.Body>
                  {field_article_category ? (
                    <span className={`article-teasers__category ${dataHome ? ("hr hr--bottom") : ("")}`}>{field_article_category}</span>
                  ) : null}
                  <Card.Title>
                    <Link to={ node.path.alias }>
                      { node.title }
                    </Link>
                  </Card.Title>
                  <Card.Text>{ellipsize(node.field_summary_plain, 200)}</Card.Text>
                  {buttons}
                </Card.Body>
              </Card>
          </Col>
        )

        // loop through the column pattern
        colIndex += 1
        if(colIndex >= colIndexTot) colIndex = 0

      }
      return true;

    })
  }


  if(list.length > 0){
    let returnTitle = ""
    if(title !== "") {
      returnTitle = (
        <Row>
          <Col>
            <FramerMotionAnimation delay={1} opacityStart={0} opacityEnd={1} transformXStart={-50} transformXEnd={0} transformYStart={0} transformYEnd={0}>
              <div className="paragraph__title">
                <div className="h3">{title}</div>
              </div>
            </FramerMotionAnimation>
          </Col>
          {moreLink !== "" ? (
            <div className="col article-teasers__more-link article-teasers__more-link--desktop">
              {moreLink}
            </div>
          ) : null}
        </Row>
      )
    }
    const returnTeasers = (
      <Container fluid>
        {returnTitle}

        <FramerMotionAnimation delay={0.5} opacityStart={0} opacityEnd={1} transformXStart={0} transformXEnd={0} transformYStart={50}
 transformYEnd={0}>
        <Row className="g-0">
          {list}
        </Row>
        </FramerMotionAnimation>
        {moreLink !== "" ? (
          <div className="article-teasers__more-link article-teasers__more-link--mobile">
            {moreLink}
          </div>
        ) : null}
      </Container>
    )
    return (returnTeasers)
  }
  else {
    return (list)
  }

}



const ArticleTeasers = (props) => {

  return (
    <>
      {teaserArticles(props.data, props.excludeNode, props.title, props.limit, props.colPattern, props.noMoreLink, props.noDates, props.classes, props.dataHome, props.downloadLinks)}
    </>
  )
}


export default ArticleTeasers
